import React from 'react';
export const Logo = ({
  className = ''
}) => {
  return <div className={`flex items-center ${className}`} data-id="element-230">
      <div className="relative mr-2" data-id="element-231">
        <div className="w-8 h-8 bg-indigo-600 rounded-lg transform rotate-45" data-id="element-232"></div>
        <div className="absolute top-0 left-0 w-8 h-8 bg-blue-500 rounded-lg opacity-70 transform rotate-12" data-id="element-233"></div>
      </div>
      <div className="text-xl font-bold" data-id="element-234">
        <span className="text-gray-800" data-id="element-235">nterprise</span>
        <span className="text-indigo-600" data-id="element-236">AI</span>
      </div>
    </div>;
};